export type Language = 'fr' | 'ru';

export const translations = {
  fr: {
    // Navigation
    nav_dashboard: 'Tableau de bord',
    nav_learning: 'Parcours d\'apprentissage',
    nav_lesson: 'Leçon',
    nav_leaderboard: 'Classement',
    nav_admin: 'Administration',
    nav_profile: 'Profil',
    nav_logout: 'Déconnexion',
    nav_settings: 'Paramètres',

    // Auth
    auth_login: 'Connexion',
    auth_signup: 'S\'inscrire',
    auth_email: 'Adresse e-mail',
    auth_password: 'Mot de passe',
    auth_confirm_password: 'Confirmer le mot de passe',
    auth_name: 'Nom complet',
    auth_remember: 'Se souvenir de moi',
    auth_forgot: 'Mot de passe oublié?',
    auth_no_account: 'Pas encore de compte?',
    auth_has_account: 'Déjà un compte?',
    auth_google: 'Continuer avec Google',
    auth_welcome: 'Bienvenue sur Vika Comptable',
    auth_tagline: 'Apprenez la comptabilité comme un jeu',
    auth_feature_1: 'Leçons interactives en français et russe',
    auth_feature_2: 'Système de gamification avec XP et badges',
    auth_feature_3: 'Classements hebdomadaires et mensuels',
    auth_feature_4: 'Certificats téléchargeables',

    // Dashboard
    dash_welcome: 'Bonjour',
    dash_streak: 'Jours consécutifs',
    dash_xp: 'Points XP',
    dash_rank: 'Rang actuel',
    dash_lessons: 'Leçons complétées',
    dash_weekly_xp: 'XP cette semaine',
    dash_accuracy: 'Taux de précision',
    dash_next_lesson: 'Prochaine leçon',
    dash_continue: 'Continuer',
    dash_achievements: 'Succès récents',
    dash_activity: 'Activité XP (7 jours)',
    dash_progress: 'Progression globale',
    dash_level_progress: 'Progression du niveau',

    // Learning
    learning_title: 'Parcours d\'apprentissage',
    learning_subtitle: 'Maîtrisez la comptabilité étape par étape',
    learning_locked: 'Verrouillé',
    learning_completed: 'Complété',
    learning_in_progress: 'En cours',
    learning_available: 'Disponible',
    learning_xp_reward: 'XP à gagner',
    learning_start: 'Commencer',
    learning_continue: 'Continuer',
    learning_review: 'Réviser',

    // Lesson
    lesson_theory: 'Théorie',
    lesson_example: 'Exemple',
    lesson_exercise: 'Exercice',
    lesson_quiz: 'Quiz',
    lesson_result: 'Résultat',
    lesson_next: 'Suivant',
    lesson_back: 'Retour',
    lesson_check: 'Vérifier',
    lesson_debit: 'Débit',
    lesson_credit: 'Crédit',
    lesson_correct: 'Correct!',
    lesson_incorrect: 'Incorrect',
    lesson_xp_earned: 'XP gagnés',
    lesson_accuracy: 'Précision',
    lesson_complete: 'Leçon terminée!',
    lesson_next_lesson: 'Leçon suivante',
    lesson_back_to_path: 'Retour au parcours',

    // Leaderboard
    lb_title: 'Classement',
    lb_weekly: 'Hebdomadaire',
    lb_monthly: 'Mensuel',
    lb_global: 'Global',
    lb_rank: 'Rang',
    lb_player: 'Joueur',
    lb_xp: 'XP',
    lb_streak: 'Série',
    lb_your_rank: 'Votre classement',

    // Admin
    admin_title: 'Administration',
    admin_overview: 'Vue d\'ensemble',
    admin_lessons: 'Leçons',
    admin_users: 'Utilisateurs',
    admin_stats: 'Statistiques',
    admin_reports: 'Rapports',
    admin_add_lesson: 'Ajouter une leçon',
    admin_edit: 'Modifier',
    admin_delete: 'Supprimer',
    admin_save: 'Enregistrer',
    admin_cancel: 'Annuler',

    // Ranks
    rank_student: 'Étudiant',
    rank_apprentice: 'Apprenti',
    rank_assistant: 'Assistant Comptable',
    rank_accountant: 'Comptable',
    rank_senior: 'Comptable Senior',
    rank_expert: 'Expert Comptable',

    // Common
    common_loading: 'Chargement...',
    common_error: 'Une erreur s\'est produite',
    common_save: 'Enregistrer',
    common_cancel: 'Annuler',
    common_delete: 'Supprimer',
    common_edit: 'Modifier',
    common_view: 'Voir',
    common_close: 'Fermer',
    common_search: 'Rechercher',
    common_filter: 'Filtrer',
    common_export: 'Exporter',
    common_days: 'jours',
  },
  ru: {
    // Navigation
    nav_dashboard: 'Панель управления',
    nav_learning: 'Путь обучения',
    nav_lesson: 'Урок',
    nav_leaderboard: 'Рейтинг',
    nav_admin: 'Администрация',
    nav_profile: 'Профиль',
    nav_logout: 'Выход',
    nav_settings: 'Настройки',

    // Auth
    auth_login: 'Войти',
    auth_signup: 'Зарегистрироваться',
    auth_email: 'Электронная почта',
    auth_password: 'Пароль',
    auth_confirm_password: 'Подтвердите пароль',
    auth_name: 'Полное имя',
    auth_remember: 'Запомнить меня',
    auth_forgot: 'Забыли пароль?',
    auth_no_account: 'Нет аккаунта?',
    auth_has_account: 'Уже есть аккаунт?',
    auth_google: 'Войти через Google',
    auth_welcome: 'Добро пожаловать в Vika Comptable',
    auth_tagline: 'Учите бухгалтерию как игру',
    auth_feature_1: 'Интерактивные уроки на французском и русском',
    auth_feature_2: 'Система геймификации с XP и значками',
    auth_feature_3: 'Еженедельные и ежемесячные рейтинги',
    auth_feature_4: 'Скачиваемые сертификаты',

    // Dashboard
    dash_welcome: 'Добрый день',
    dash_streak: 'Дней подряд',
    dash_xp: 'Очки XP',
    dash_rank: 'Текущий ранг',
    dash_lessons: 'Уроков завершено',
    dash_weekly_xp: 'XP за неделю',
    dash_accuracy: 'Точность ответов',
    dash_next_lesson: 'Следующий урок',
    dash_continue: 'Продолжить',
    dash_achievements: 'Последние достижения',
    dash_activity: 'Активность XP (7 дней)',
    dash_progress: 'Общий прогресс',
    dash_level_progress: 'Прогресс уровня',

    // Learning
    learning_title: 'Путь обучения',
    learning_subtitle: 'Освойте бухгалтерию шаг за шагом',
    learning_locked: 'Заблокировано',
    learning_completed: 'Завершено',
    learning_in_progress: 'В процессе',
    learning_available: 'Доступно',
    learning_xp_reward: 'XP для получения',
    learning_start: 'Начать',
    learning_continue: 'Продолжить',
    learning_review: 'Повторить',

    // Lesson
    lesson_theory: 'Теория',
    lesson_example: 'Пример',
    lesson_exercise: 'Упражнение',
    lesson_quiz: 'Тест',
    lesson_result: 'Результат',
    lesson_next: 'Далее',
    lesson_back: 'Назад',
    lesson_check: 'Проверить',
    lesson_debit: 'Дебет',
    lesson_credit: 'Кредит',
    lesson_correct: 'Правильно!',
    lesson_incorrect: 'Неправильно',
    lesson_xp_earned: 'XP получено',
    lesson_accuracy: 'Точность',
    lesson_complete: 'Урок завершен!',
    lesson_next_lesson: 'Следующий урок',
    lesson_back_to_path: 'Вернуться к пути',

    // Leaderboard
    lb_title: 'Рейтинг',
    lb_weekly: 'Еженедельный',
    lb_monthly: 'Ежемесячный',
    lb_global: 'Глобальный',
    lb_rank: 'Ранг',
    lb_player: 'Игрок',
    lb_xp: 'XP',
    lb_streak: 'Серия',
    lb_your_rank: 'Ваш рейтинг',

    // Admin
    admin_title: 'Администрация',
    admin_overview: 'Обзор',
    admin_lessons: 'Уроки',
    admin_users: 'Пользователи',
    admin_stats: 'Статистика',
    admin_reports: 'Отчеты',
    admin_add_lesson: 'Добавить урок',
    admin_edit: 'Редактировать',
    admin_delete: 'Удалить',
    admin_save: 'Сохранить',
    admin_cancel: 'Отмена',

    // Ranks
    rank_student: 'Студент',
    rank_apprentice: 'Ученик',
    rank_assistant: 'Помощник бухгалтера',
    rank_accountant: 'Бухгалтер',
    rank_senior: 'Старший бухгалтер',
    rank_expert: 'Эксперт-бухгалтер',

    // Common
    common_loading: 'Загрузка...',
    common_error: 'Произошла ошибка',
    common_save: 'Сохранить',
    common_cancel: 'Отмена',
    common_delete: 'Удалить',
    common_edit: 'Редактировать',
    common_view: 'Просмотр',
    common_close: 'Закрыть',
    common_search: 'Поиск',
    common_filter: 'Фильтр',
    common_export: 'Экспорт',
    common_days: 'дней',
  },
};

export type TranslationKey = keyof typeof translations.fr;

export function t(lang: Language, key: TranslationKey): string {
  return translations[lang][key] ?? key;
}